<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px" scrollable :fullscreen="$vuetify.breakpoint.name == `xs`">
            <v-card :loading="loading" outlined>
                <v-card-title class="primary" dense>
                    <span class="headline text-uppercase white--text">{{ title }}</span>
                </v-card-title>
                <v-card-text>
                    <v-subheader class="title">Dados do Usuário</v-subheader>
                    <v-form  ref="form" v-model="valid" :lazy-validation="lazy">
                        <v-row>
                            <v-col cols="5">
                                <v-text-field v-model="user.username" :rules="[required]" label="User Name" outlined></v-text-field>
                            </v-col>
                            <v-col cols="7">
                                <v-text-field v-model="user.email" :rules="[required, email_required]" label="E-mail" type="email" outlined></v-text-field>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-subheader class="title">Configurações</v-subheader>
                        <v-row  dense>
                            <v-col cols="12" sm="6">
                                <v-switch v-model="user.enabled" color="primary" inset :true-value="1" :false-value="0" label="Habilitado" hide-details></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-switch v-model="user.credentialsnonexpired" color="primary" inset :true-value="1" :false-value="0" label="Credencial Não Expira" hide-details></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-switch v-model="user.accountnonexpired" color="primary" inset :true-value="1" :false-value="0" label="Conta não Expira" hide-details></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-switch v-model="user.accountnonlocked" color="primary" inset :true-value="1" :false-value="0" label="Conta não Bloqueada" hide-details></v-switch>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="close" outlined>
                        <v-icon left>mdi-close-circle-outline</v-icon>FECHAR
                    </v-btn>
                    <v-btn color="primary" @click="save" :disabled="!canSave">
                        <v-icon left>mdi-content-save-outline</v-icon>SALVAR
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { required, email_required } from '@/utils/roles.js'
    import { mapGetters } from 'vuex'

    export default {
        data: () => ({
            loading: null,
            valid: null,
            lazy: false
        }),
        computed: {
            ...mapGetters('app', ['hasRole']),
            title() {
                if (this.user.id) {
                    return 'Usuário: '+ this.user.username
                }
                return 'Novo Usuário'                
            },
            dialog: {
                get() { return this.value },
                set(v) { this.$emit('input', v) }
            },
            canSave() {
                if (this.user.id) {
                    return this.hasRole([`ADMIN`, `user:update`])
                }
                return this.hasRole([`ADMIN`, `user:create`])
            }
        },
        methods: {
            required,
            email_required,
            save() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    if (this.user.id) {
                        this.update(this.user)
                    }
                    else {
                        this.insert(this.user)
                    }
                }
            },
            insert(item) {
                var context = this
                this.axios.post(this.$store.state.url_api + '/user/', item)
                    .then(r => {
                        context.loading = false
                        context.$emit('save', { item: r.data, isNew: true })
                    })
                    .catch(() => {
                        context.loading = false
                    })
            },
            update(item) {
                var context = this
                delete item.loading
                this.axios.put(this.$store.state.url_api + '/user/' + item.id, item)
                    .then(() => {
                        context.loading = false
                        context.$emit('save', { item: context.user })
                        context.dialog = false
                    })
                    .catch(() => {
                        context.loading = false
                    })
            },
            close() {
                this.dialog = false
                this.$emit('clear')
                this.$refs.form.reset()
            }
        },
        props: {
            value: Boolean,
            user: {},
            index: Number
        }   
    }
</script>